import React, { FC } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
// import { DialogPayload } from 'src/redux/types/redux.types';
import { RootState } from "src/redux/config/rootReducer";

import AppDialog from './AppDialog';


const AppDialogs: FC<{}> = () => {
  const dialogs = useSelector((state: RootState) => state.overlays.dialogs);
  return (
    <>
      {dialogs.map(dialog => (
        <AppDialog key={dialog.id} {...dialog} />
      ))}
    </>
  );
};

export default AppDialogs;
